var render, staticRenderFns
import script from "./dealer_profit_detail.vue?vue&type=script&lang=js"
export * from "./dealer_profit_detail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/jenkins/workspace/web-page/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5151e334')) {
      api.createRecord('5151e334', component.options)
    } else {
      api.reload('5151e334', component.options)
    }
    
  }
}
component.options.__file = "found/views/cps/views/rights/fee/dealer_profit_detail/dealer_profit_detail.vue"
export default component.exports